import { useEffect } from "react";

/**
 * Lightweight page that the Google Drive OAuth popup lands on after a
 * successful connection.  It immediately calls window.close() so the popup
 * disappears and the parent window's DriveStatusIndicator (which polls for
 * the popup closing) can re-check the token status and update the indicator.
 */
export default function GDriveSuccess() {
  useEffect(() => {
    // Give the browser a single paint cycle to render the message, then close.
    const t = setTimeout(() => window.close(), 300);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        fontFamily: "sans-serif",
        gap: "12px",
        color: "#333",
      }}
    >
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill="#22c55e" />
        <path d="M14 24l8 8 12-14" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <p style={{ fontSize: "16px", fontWeight: 600 }}>Google Drive connected!</p>
      <p style={{ fontSize: "13px", color: "#666" }}>This window will close automatically.</p>
    </div>
  );
}
